<h3 mat-dialog-title>{{ isEdit ? 'Edit' : 'Add' }} AWS Email Template</h3>
<form [formGroup]="templateForm" (ngSubmit)="submit()">
  <div mat-dialog-content>
    <div class="mat-input-group">
      <mat-form-field>
        <input matInput placeholder="Template Name" formControlName="TemplateName">
      </mat-form-field>
    </div>
    <div class="mat-input-group">
      <mat-form-field>
        <input matInput placeholder="Subject" formControlName="SubjectPart">
      </mat-form-field>
    </div>
    <div class="mat-input-group">
      <mat-form-field>
        <textarea matInput rows="8" placeholder="HTML Content" formControlName="HtmlPart"></textarea>
      </mat-form-field>
    </div>
    <div class="mat-input-group">
      <mat-form-field>
        <textarea matInput rows="4" placeholder="Plain Text (optional)" formControlName="TextPart"></textarea>
      </mat-form-field>
    </div>
  </div>
  <div mat-dialog-actions align="end">
    <button mat-stroked-button type="button" (click)="close()">Cancel</button>
    <button mat-raised-button color="primary" type="submit" [disabled]="templateForm.invalid">Save</button>
  </div>
</form>
